import { useEffect, useState } from "react";
import { axios } from "helper/axios";

const ICON_IMAGES_API = "dashboard/icon-images";

const getImagesMetadata = (response) => {
  const payload = response?.data ?? response ?? {};
  return payload?.images_metadata ?? payload?.imagesMetadata ?? null;
};

/**
 * Always use `web` URLs — mobile assets are the same in this campaign.
 * Returns `{ PORTFOLIO: url, ONESTOCK: url, RMS: url, ... }`.
 */
export const parseDashboardIconImages = (response) => {
  const metadata = getImagesMetadata(response);
  const web = Array.isArray(metadata?.web) ? metadata.web : [];
  const map = {};

  web.forEach((item) => {
    const code = item?.productCode || item?.product_code;
    const url = typeof item?.imageUrl === "string" ? item.imageUrl.trim() : "";
    if (code && url) {
      map[code] = url;
    }
  });

  return map;
};

export const useDashboardIconImages = () => {
  const [iconByProductCode, setIconByProductCode] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        const response = await axios.get(ICON_IMAGES_API, {
          skipErrorToast: true,
        });
        if (!cancelled) {
          setIconByProductCode(parseDashboardIconImages(response));
        }
      } catch (error) {
        console.error("Failed to load dashboard icon images:", error);
        if (!cancelled) {
          setIconByProductCode({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { iconByProductCode, loading };
};

export default useDashboardIconImages;
